// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t69Z","colMin":"styles_colMin__wwN_J"};